import { render, staticRenderFns } from "./ThingsToNote2.vue?vue&type=template&id=4013c9f6&"
import script from "./ThingsToNote2.vue?vue&type=script&lang=js&"
export * from "./ThingsToNote2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports